import { z } from 'zod';

import { ColorPalette } from '@/entities/chart';
import ColorPaletteSelector from '@/features/dashboard/components/AppForm/AppForm/components/ColorPaletteSelector';
import { ItemSelection } from '@/features/dashboard/components/AppForm/AppForm/components/ItemSelection';
import { SelectChartType } from '@/features/dashboard/components/AppForm/AppForm/components/SelectChartType';
import { TabName } from '@/features/dashboard/components/AppForm/AppForm/components/TabName';
import type { ChartFormValues } from '@/features/dashboard/components/AppForm/AppForm/context/types';
import { DrawerStep } from '@/features/dashboard/components/Drawer/types';
import { SPOT_CHART_MAX_ITEMS } from '@/features/dashboard/constants/const';
import type { SimpleChartWidgetV2 } from '@/features/dashboard/types';
import { AppType } from '@/features/dashboard/types';

import type { FormAppDefinition } from '../types';
import {
  buildChart,
  ColorPaletteSchema,
  graphToFormValues,
  NameSchema,
  SymbolsStateSchema
} from './_helpers';

export const spotChartDefinition: FormAppDefinition<ChartFormValues, SimpleChartWidgetV2> = {
  type: AppType.Spot,
  drawerStep: DrawerStep.SelectSpotChart,
  dashboardControls: { edit: true },
  widgetControls: { export: true },
  maxItems: SPOT_CHART_MAX_ITEMS,
  initialValues: {
    name: 'Spot History chart',
    type: AppType.Spot,
    symbols: { active: [], backlog: [] },
    colorPalette: ColorPalette.Vibrant
  },
  schema: z.object({
    id: z.string().optional(),
    type: z.literal(AppType.Spot),
    name: NameSchema,
    symbols: SymbolsStateSchema,
    colorPalette: ColorPaletteSchema,
    from: z.string().optional()
  }),
  heading: { title: 'Configure spot chart', subtitle: 'Set up your chart preferences and data' },
  Form: () => (
    <div className='flex flex-col gap-6'>
      <TabName />
      <SelectChartType />
      <ItemSelection />
      <ColorPaletteSelector />
    </div>
  ),
  toWidget: values => buildChart(values),
  canEditWidget: (w): w is SimpleChartWidgetV2 => w.type === 'graph' && !w.metadata?.graphType,
  fromWidget: w => ({ ...graphToFormValues(w), type: AppType.Spot })
};
